// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.normal-overlay #overlay {
  background: #fff;
  color: #666666;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 5000;
  top: 0;
  left: 0;
  float: left;
  text-align: center;
  padding-top: 25%;
  opacity: 0.8;
}
.normal-overlay .spinner {
  margin: 0 auto;
  height: 64px;
  width: 64px;
  animation: rotate 0.8s infinite linear;
  border: 5px solid #112a3e;
  border-right-color: transparent;
  border-radius: 50%;
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.advert-overlay #overlay {
  color: #000;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 5000;
  top: 0;
  left: 0;
  float: left;
  text-align: center;
  background: rgba(255, 255, 255, 0.8);
}
.advert-overlay .loading-container {
  background-color: #f6f6f6;
  border: #112a3e solid 4px;
}
.advert-overlay .progress-line,
.advert-overlay .progress-line:before {
  height: 8px;
  width: 100%;
  margin: 0;
}
.advert-overlay .progress-line {
  background-color: #c9e8fb;
  display: flex;
}
.advert-overlay .progress-line:before {
  background-color: #112a3e;
  content: "";
  animation: running-progress 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@keyframes running-progress {
  0% {
    margin-left: 0px;
    margin-right: 100%;
  }
  50% {
    margin-left: 25%;
    margin-right: 0%;
  }
  100% {
    margin-left: 100%;
    margin-right: 0;
  }
}`, "",{"version":3,"sources":["webpack://./libs/msslib/src/lib/components/loading/loading.component.scss"],"names":[],"mappings":"AAGE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAFJ;AAKE;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,sCAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;AAHJ;AAKE;EACE;IACE,uBAAA;EAHJ;EAKE;IACE,yBAAA;EAHJ;AACF;;AASE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;AANJ;AASE;EACE,yBAAA;EACA,yBAAA;AAPJ;AAUE;;EAEE,WAAA;EACA,WAAA;EACA,SAAA;AARJ;AAUE;EACE,yBAAA;EAEA,aAAA;AARJ;AAUE;EACE,yBAAA;EACA,WAAA;EAEA,oEAAA;AARJ;AAwBE;EACE;IACE,gBAAA;IACA,kBAAA;EARJ;EAUE;IACE,gBAAA;IACA,gBAAA;EARJ;EAUE;IACE,iBAAA;IACA,eAAA;EARJ;AACF","sourcesContent":["@use 'mssvariables' as *;\n\n.normal-overlay {\n  #overlay {\n    background: theme-color('white');\n    color: #666666;\n    position: fixed;\n    height: 100%;\n    width: 100%;\n    z-index: 5000;\n    top: 0;\n    left: 0;\n    float: left;\n    text-align: center;\n    padding-top: 25%;\n    opacity: 0.8;\n  }\n\n  .spinner {\n    margin: 0 auto;\n    height: 64px;\n    width: 64px;\n    animation: rotate 0.8s infinite linear;\n    border: 5px solid theme-color('dark-blue');\n    border-right-color: transparent;\n    border-radius: 50%;\n  }\n  @keyframes rotate {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n}\n\n// Advert overlay\n.advert-overlay {\n  #overlay {\n    color: theme-color('dark');\n    position: fixed;\n    height: 100%;\n    width: 100%;\n    z-index: 5000;\n    top: 0;\n    left: 0;\n    float: left;\n    text-align: center;\n    background: rgba(255, 255, 255, 0.8);\n  }\n\n  .loading-container {\n    background-color: theme-color('light');\n    border: theme-color('dark-blue') solid 4px;\n  }\n\n  .progress-line,\n  .progress-line:before {\n    height: 8px;\n    width: 100%;\n    margin: 0;\n  }\n  .progress-line {\n    background-color: theme-color('pastel-blue');\n    display: -webkit-flex;\n    display: flex;\n  }\n  .progress-line:before {\n    background-color: theme-color('dark-blue');\n    content: '';\n    -webkit-animation: running-progress 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n    animation: running-progress 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n  }\n  @-webkit-keyframes running-progress {\n    0% {\n      margin-left: 0px;\n      margin-right: 100%;\n    }\n    50% {\n      margin-left: 25%;\n      margin-right: 0%;\n    }\n    100% {\n      margin-left: 100%;\n      margin-right: 0;\n    }\n  }\n  @keyframes running-progress {\n    0% {\n      margin-left: 0px;\n      margin-right: 100%;\n    }\n    50% {\n      margin-left: 25%;\n      margin-right: 0%;\n    }\n    100% {\n      margin-left: 100%;\n      margin-right: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
